import { render, staticRenderFns } from "./MenuEditFoods.vue?vue&type=template&id=2ba83964&scoped=true"
import script from "./MenuEditFoods.vue?vue&type=script&lang=js"
export * from "./MenuEditFoods.vue?vue&type=script&lang=js"
import style0 from "./MenuEditFoods.vue?vue&type=style&index=0&id=2ba83964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba83964",
  null
  
)

export default component.exports